<template>
  <TheLoader :active="true" v-if="loading"/>
  <div class="content-container flex-row" v-else>
    <section class="content white">
      <TheLoader :active="updating" style="opacity:0.5"/>
      <TheEmptyList v-if="items.length < 1" :title="'Ingen fullmakt'" :large="true" :icon="'glyph-medium-object'"/>

      <a href="javascript:;" @click="openFullmaktModal()" class="button action fixed right glyph data-modal">
        <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-contract"></use></svg>
        <span>Ny fullmakt</span>
      </a>

      <table v-if="items.length > 0" class="large fixed sortable clickable evenodd contracts table-filter sticky-table-header">
        <thead>
          <tr>
            <th v-for="(heading, index) in headings" v-bind:key="index" v-bind:class="[heading.class, heading.sortKey === queryParams.sort ? sortClass : '']" @click="changeSorting(heading.sortKey)">
              {{heading.name}}
              <span id="sorttable_sortrevind" v-if="heading.sortKey === queryParams.sort && queryParams.direction === 'desc'">&nbsp;</span>
              <span id="sorttable_sortfwdind" v-if="heading.sortKey === queryParams.sort && queryParams.direction === 'asc'">&nbsp;</span>
            </th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="item in items" v-bind:key="item.id" class="all takst" @click="openFullmaktModal(item)">
            <td>{{item.Telefon}}</td>
            <td>{{item.Fnavn || '-'}}</td>
            <td>{{item.Enavn || '-'}}</td>
            <td>{{item.legitimasjon ? item.legitimasjon.Tekst : '-'}}</td>
            <td>
              <span class="statusicon verified" v-if="item.Legitimert">
                <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-success"></use></svg>
              </span>
              <span class="statusicon unverified" v-else>
                <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-error"></use></svg>
              </span>
            </td>
            <td>{{item.Utlopsdato | avantidate}}</td>
            <td class="align-right">{{item.Sist_endret_tid | avantidatetime}}</td>
          </tr>
        </tbody>
      </table>

      <div class="pagination-container"  v-if="pageCount > 1">
        <paginate v-model="currentPage"
          :page-count="pageCount"
          :page-range="11"
          :click-handler="changePage"
          :container-class="'pagination'"
          :prev-text="paginationArrow"
          :next-text="paginationArrow"
          :prev-class="'prev'"
          :next-class="'next'"
          >
        </paginate>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'KundeCardShowTabFullmakt',
  props: {
    kunde: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      currentPage: 1, // Just for the pagination component
      headings: [
        {name: 'Telefon', sortKey: 'Telefon', class: ''},
        {name: 'Fnavn', sortKey: 'Fnavn', class: ''},
        {name: 'Enavn', sortKey: 'Enavn', class: ''},
        {name: 'Legitimasjon', sortKey: 'legitimasjon.Tekst', class: ''},
        {name: 'Legitimert', sortKey: 'Legitimert', class: ''},
        {name: 'Utlopsdato', sortKey: 'Utlopsdato', class: ''},
        {name: 'Dato endret', sortKey: 'Sist_endret_tid', class: 'align-right'}
      ]
    }
  },
  created () {
    // Note: The fetch of items is done in KundeCard.

    this.currentPage = this.queryParams.page || 1
  },
  computed: {
    ...mapGetters('kundefullmakt', [
      'items',
      'pageCount',
      'queryParams',
      'loading',
      'updating'
    ]),
    sortClass: function () {
      return 'sorttable_sorted' + (this.queryParams.direction !== 'asc' ? '_reverse' : '')
    }
  },
  methods: {
    changePage: function (page) {
      // Update a copy of the query params, to send to our store
      let copiedParams = this._.clone(this.queryParams)
      this.currentPage = page
      copiedParams.page = this.currentPage

      this.$store.dispatch('kundefullmakt/reload', {
        Kundenr: this.kunde.Kundenr,
        queryParams: copiedParams
      })
    },
    changeSorting: function (sortKey) {
      if (!sortKey) {
        return
      }

      // Update a copy of the query params, to send to our store
      let copiedParams = this._.clone(this.queryParams)
      this.currentPage = 1
      copiedParams.page = this.currentPage

      if (copiedParams.sort === sortKey) {
        copiedParams.direction = copiedParams.direction === 'asc' ? 'desc' : 'asc'
      } else {
        copiedParams.direction = 'asc'
      }

      copiedParams.sort = sortKey

      this.$store.dispatch('kundefullmakt/reload', {
        Kundenr: this.kunde.Kundenr,
        queryParams: copiedParams
      })
    },
    openFullmaktModal: function (item) {
      let payload = {
        kunde: this.kunde
      }

      if (item) {
        payload.fullmakt = item
      }

      this.openModal(
        'kunde-fullmakt-form-modal',
        payload
      )
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/KundeCardShowTabFullmakt.vue